export enum themePalette {
  blue = '#08142F',
  yellow = '#eecb2b',
  lighgreen = '#4FADA6',
  gray = '#717171',
  red= '#CC3044',
  SUCCESS= '#4FADA6',
  BG_SECONDARY = '#000',
  LIME = '#C8FA5F',
  TEXT = '#FFF',
  darkBlue = '#071C3E',
  white = '#FFFFFF',
  // FONT_GLOBAL = "'JetBrains Mono', monospace",
}
